export default __webpack_public_path__ + "static/media/property_558.0ea5fd38.png";